import React, { useEffect, PureComponent } from "react";
import {
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Area,
  Tooltip,
  AreaChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Legend,
  RadialBarChart,
  RadialBar,
  Bar,
  BarChart,
} from "recharts";
import StatsService from "../../apiservices/StatsService";
import { Loader } from "@fluentui/react-northstar";

export default class DistributionByQueue extends PureComponent {
  state = {
    data: [],
    isLoading: true,
  };
  componentDidMount() {
    const username = sessionStorage.getItem("userName");
    const tokenString = sessionStorage.getItem("tokenStats");
    const company = sessionStorage.getItem("company");
    for (let queue of this.props.queue) {
      StatsService.getDistributionByQueue(
        this.props.initDate,
        this.props.endDate,
        queue,
        tokenString,
        username,
        company
      ).then((res) => {
        console.log(res.data[0]);
        this.setState((prevState) => ({
          data: [...prevState.data, res.data[0]],
        }));
        this.setState({
          isLoading: false,
        });
      });
    }
  }

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader
            styles={{
              marginTop: "20%",
            }}
          />
        ) : (
          <ResponsiveContainer>
            <BarChart
              width={800}
              height={500}
              data={this.state.data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Atendidas" fill="#8884d8" />
              <Bar dataKey="No Atendidas" fill="#82ca9d" />
              <Bar dataKey="Abandonadas" fill="#4f6bed" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </>
    );
  }
}
